import React, { useState } from 'react';
import PageHeader from './PageHeader';
import JETIR2510251 from '../assets/JETIR2510251.pdf';
import Summery from "../assets/Project Executive Summary.pdf";
import ResearchPaper from "../assets/Research Paper-research converse.pdf";

const Research_And_Development = () => {

    const [activeTab, setActiveTab] = useState('project');


    const [previewFile, setPreviewFile] = useState(null);


    const projectData = {
        title: "Minor project awarded or sponsored by Department of Higher Education, Govt of Uttar Pradesh",
        projectTitle: "Contribution of Women to the Economy in the India–Nepal Border Areas",
        executiveSummaryUrl: Summery,
        researchPaperUrl: ResearchPaper,
    };


    const publications = [
        {
            id: 1,
            title: "Journal of Emerging Technologies and Innovative Research (JETIR)",

            link: JETIR2510251,
        },

    ];

    // Handler for file download/preview
    const handleFileClick = (fileType, fileUrl) => {
        console.log(`Opening ${fileType} from: ${fileUrl}`);
        window.open(fileUrl, "_blank");
        setPreviewFile(fileType);
        setTimeout(() => setPreviewFile(null), 3000);
    };

    return (
        <>
            <PageHeader title="Research & Development" />

            <div className="research-development-container">

                <div className="tab-buttons">
                    <button
                        className={`tab-btn ${activeTab === 'project' ? 'active' : ''}`}
                        onClick={() => setActiveTab('project')}
                    >
                        Research Project
                    </button>
                    <button
                        className={`tab-btn ${activeTab === 'publications' ? 'active' : ''}`}
                        onClick={() => setActiveTab('publications')}
                    >
                        Research Publications
                    </button>
                </div>


                {activeTab === 'project' && (
                    <section className="rd-section research-project-section">
                        <div className="project-badge">
                            Minor Project Awarded / Sponsored by Department of Higher Education, Govt of Uttar Pradesh
                        </div>
                        <div className="project-card">

                            <div className="project-title">
                                <strong>Title of the Project:</strong> {projectData.projectTitle}
                            </div>

                            <div className="file-attachments">
                                <h3>Attachments:</h3>
                                <ul className="file-list">
                                    <li>
                                        <button
                                            className="file-link-btn"
                                            onClick={() => handleFileClick("Executive Summary", projectData.executiveSummaryUrl)}
                                        >
                                             Executive Summary (Enclosed)
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="file-link-btn"
                                            onClick={() => handleFileClick("Research Papers", projectData.researchPaperUrl)}
                                        >
                                             Research Papers published as part of the project
                                        </button>
                                    </li>
                                </ul>
                                
                            </div>
                        </div>
                    </section>
                )}

                {/* Tab Content - Research Publications */}
                {activeTab === 'publications' && (
                    <section className="rd-section research-publications-section">
                        <div className="publications-list">
                            {publications.map((pub) => (
                                <div key={pub.id} className="publication-item">
                                    <div className="pub-title">{pub.title}</div>

                                    <a href={pub.link} className="pub-link" target="_blank" rel="noopener noreferrer">
                                        View Publication →
                                    </a>
                                </div>
                            ))}
                        </div>
                    </section>
                )}

                <style>{`
                    .research-development-container {
                        max-width: 1200px;
                        margin: 0 auto;
                        padding: 2rem 1.5rem;
                        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                        border-radius: 16px;
                    }

                    .rd-header {
                        text-align: center;
                        margin-bottom: 2rem;
                        padding-bottom: 1rem;
                        border-bottom: 3px solid #2c7da0;
                    }

                    .rd-header h1 {
                        font-size: 2.5rem;
                        color: #0b3b4f;
                        margin: 0;
                        font-weight: 600;
                    }

                    .rd-header p {
                        color: #2c7da0;
                        font-size: 1.1rem;
                        margin-top: 0.5rem;
                    }

                    /* Tab Buttons Styling */
                    .tab-buttons {
                        display: flex;
                        gap: 1rem;
                        margin-bottom: 2rem;
                        border-bottom: 2px solid #e2e8f0;
                        padding-bottom: 0;
                    }

                    .tab-btn {
                        background: transparent;
                        border: none;
                        padding: 0.8rem 1.8rem;
                        font-size: 1rem;
                        font-weight: 600;
                        color: #64748b;
                        cursor: pointer;
                        border-radius: 8px 8px 0 0;
                        transition: all 0.3s ease;
                        position: relative;
                    }

                    .tab-btn:hover {
                        color: #2c7da0;
                        background: #f1f5f9;
                    }

                    .tab-btn.active {
                        color: #2c7da0;
                        background: #f8fafc;
                    }

                    .tab-btn.active::after {
                        content: '';
                        position: absolute;
                        bottom: -2px;
                        left: 0;
                        right: 0;
                        height: 3px;
                        background: #2c7da0;
                        border-radius: 3px 3px 0 0;
                    }

                    .rd-section {
                        background: white;
                        border-radius: 20px;
                        padding: 1.8rem;
                        margin-bottom: 2.5rem;
                    
                        transition: transform 0.2s;
                        animation: fadeIn 0.3s ease;
                    }

                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    .rd-section:hover {
                        transform: translateY(-3px);
                    }

                    .project-card {
                        background: #f1f5f9;
                        border-radius: 16px;
                        padding: 1.5rem;
                    }

                    .project-badge {

                        color: black;
                        display: inline-block;
                        padding: 0.4rem 1rem;
                        border-radius: 30px;
                        font-size: 2rem;
                        font-weight: 500;
                        text:center;
                        margin-bottom: 1.2rem;
                    }

                    .project-title {
                        font-size: 1.2rem;
                        margin-bottom: 1.5rem;
                        padding: 0.8rem;
                        background: #e9ecef;
                        border-radius: 12px;
                    }

                    .file-attachments h3 {
                        font-size: 1.2rem;
                        margin-bottom: 0.8rem;
                        color: #0f4c5f;
                    }

                    .file-list {
                        list-style: none;
                        padding: 0;
                        display: flex;
                        gap: 1.5rem;
                        flex-wrap: wrap;
                    }

                    .file-link-btn {
                        background: none;
                        border: none;
                        color: #2c7da0;
                        font-size: 1rem;
                        cursor: pointer;
                        padding: 0.5rem 1rem;
                        border-radius: 8px;
                        transition: all 0.2s;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        background: #e2e8f0;
                    }

                    .file-link-btn:hover {
                        background: #cbd5e1;
                        transform: translateX(3px);
                    }

                    .preview-toast {
                        margin-top: 1rem;
                        padding: 0.6rem;
                        background: #ffedd5;
                        border-radius: 8px;
                        color: #b45309;
                        font-size: 0.9rem;
                        border-left: 4px solid #f59e0b;
                    }

                    .publications-list {
                        display: flex;
                        flex-direction: column;
                        gap: 1.2rem;
                    }

                    .publication-item {
                        padding: 1rem;
                        display: flex;
                        flex-direction: row ;
                        justify-content: space-between;
                        border: 1px solid #e2e8f0;
                        border-radius: 14px;
                        transition: all 0.2s;
                        background: #ffffff;
                    }

                    .publication-item:hover {
                        border-color: #2c7da0;
                        box-shadow: 0 4px 12px rgba(44,125,160,0.1);
                    }

                    .pub-title {
                        font-size: 1.1rem;
                        font-weight: 600;
                        color: #0b3b4f;
                        margin-bottom: 0.4rem;
                    }

                    .pub-details {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 1rem;
                        font-size: 0.85rem;
                        color: #4b5563;
                        margin-bottom: 0.6rem;
                    }

                    .pub-journal {
                        font-style: italic;
                    }

                    .pub-year {
                        background: #e2e8f0;
                        padding: 0.1rem 0.5rem;
                        border-radius: 20px;
                    }

                    .pub-link {
                        color: #2c7da0;
                        text-decoration: none;
                        font-size: 1.3rem;
                        font-weight: 500;
                        display: inline-flex;
                        align-items: center;
                        gap: 5px;
                    }

                    .pub-link:hover {
                        text-decoration: underline;
                    }

                    @media (max-width: 768px) {
                        .research-development-container {
                            padding: 1rem;
                        }
                        .rd-section {
                            padding: 1rem;
                        }
                        .file-list {
                            flex-direction: column;
                            gap: 0.8rem;
                        }
                        .tab-buttons {
                            flex-direction: column;
                            gap: 0.5rem;
                        }
                        .tab-btn {
                            text-align: center;
                            border-radius: 8px;
                        }
                        .tab-btn.active::after {
                            display: none;
                        }
                        .tab-btn.active {
                            background: #2c7da0;
                            color: white;
                        }
                    }
                `}</style>
            </div>
        </>
    );
};

export default Research_And_Development;